module.exports = __webpack_public_path__ + "img/sw2-b2.03b0afdf.jpg";